import { Backend } from './backend';
import { error } from '../redux/actions';

class DraftOrderApi {
    constructor() {
        this.path = '/retailers/order/draft';
    }

    create = async (draftOrder) => {
        try {
            return await Backend.send({
                method: 'post',
                url: `${this.path}`,
                body: draftOrder,
            });
        } catch (e) {
            throw e;
        }
    };

    get = async (retailerReference, jurisdiction) => {
        try {
            return await Backend.send({
                method: 'get',
                url: `${this.path}/${retailerReference}?jurisdiction=${jurisdiction}`,
            });
        } catch (e) {
            throw e;
        }
    };
}

export default DraftOrderApi;
